export default function isInIframe() {
  return ( window.self !== window.top )
}
